import React from 'react';
import ErrorBoundary from '../../../../components/ErrorBoundary';
import PbxVirtualOperator from './PbxVirtualOperator';
const PbxVirtualOperatorAmbrogioCostsList = React.lazy(() =>
  import('./PbxVirtualOperatorAmbrogioCostsList')
);

const PbxVirtualOperatorAmbrogioCostsPage = (props) => (
  <PbxVirtualOperator scrolling>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        <PbxVirtualOperatorAmbrogioCostsList {...props} />
      </React.Suspense>
    </ErrorBoundary>
  </PbxVirtualOperator>
);

export default PbxVirtualOperatorAmbrogioCostsPage;
